<template>
  <CRow class="w-100 justify-content-center">
    <CCol col="12" sm="8" md="6" lg="6" xl="5">
      <CCard class="table-setting-style">
        <CCardHeader>
          <h3>Налаштування сервісу</h3>
          <ul v-if="errors.length" style="list-style-type: none" class="p-0">
            <li v-for="error in errors" :key="error">
              <CAlert style="font-size: 12px;" show color="danger">{{ error }}</CAlert>
            </li>
          </ul>
          <CAlert v-if="success" style="font-size: 12px;" show color="success">Налаштування успішно
            збережені!
          </CAlert>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <div class="form-item mb-3" :class="{'errorInput': $v.mail_data.mail_login.$error}">
              <label>Введіть E-mail</label>
              <CInput
                  required
                  placeholder="Email"
                  prepend="@"
                  @change="$v.mail_data.mail_login.$touch()"
                  autocomplete="email"
                  @keyup.enter.native="login"
                  v-model="mail_data.mail_login"
                  class="mb-0"
                  :class=" {
                      'error': $v.mail_data.mail_login.$error
                    }"
              >
              </CInput>
              <small v-if="!$v.mail_data.mail_login.required" class="form-text errorText w-100">Необхідно вказати
                Mail.</small>
              <small v-if="!$v.mail_data.mail_login.email" class="form-text errorText w-100">Вказажіть коректний
                Mail.</small>
            </div>
            <div class="form-item mb-3" :class="{'errorInput': $v.mail_data.mail_password.$error}">
              <label>Введіть Пароль</label>
              <CInput
                  required
                  placeholder="Пароль"
                  @change="$v.mail_data.mail_password.$touch()"
                  :type="passwordFieldIdType"
                  autocomplete="curent-password"
                  @keyup.enter.native="login"
                  v-model.trim="mail_data.mail_password"
                  class="mb-0"
                  :class=" {
                      'error': $v.mail_data.mail_password.$error
                    }"
              >
                <template #prepend-content>
                  <CIcon name="cil-lock-locked"/>
                </template>
                <template #append-content>
                  <a @click="showPass" v-c-tooltip="{
                                    content: 'Показати/сховати пароль',
                                    placement: 'top'
                                }">
                    <CIcon name="cil-low-vision"/>
                  </a>
                </template>
              </CInput>
              <small v-if="!$v.mail_data.mail_password.required" class="form-text errorText w-100">Необхідно вказати
                Пароль.</small>
            </div>
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CRow class="justify-content-between flex-sm-wrap">
            <CCol col sm="4" lg="3">
              <CButton
                  class="btn-block flex-nowrap"
                  color="secondary"
                  @click="$router.go(-1)"
              >
                Назад
              </CButton>
            </CCol>
            <CCol col sm="5">
              <CButton
                  v-if="loading"
                  class="btn-block flex-nowrap"
                  color="primary"
                  disabled
              >
                <div class="  align-items-center">
                  <CSpinner color="default" size="sm"/>
                </div>
              </CButton>
              <CButton
                  v-else
                  class="btn-block"
                  color="primary"
                  @click="validation"
              >
                Зберегти
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import axios from 'axios';
import {required, email, maxLength} from 'vuelidate/lib/validators'
import {setPass, getPass} from "@/api/adminAppPassword";
import {routerGoToName} from "@/utils/routerUtils";


export default {
  name: "AdminAppPassword",
  data() {
    return {
      errors: [],
      success: false,
      loading: false,
      passwordFieldIdType: 'password',
      mail_data: {
        mail_login: '',
        mail_password: ''
      }
    }
  },
  validations: {
    mail_data: {
      mail_login: {
        maxLength: maxLength(100),
        required,
        email
      },
      mail_password: {
        required,
        maxLength: maxLength(100),
      }
    }
  },
  mounted() {
    getPass((res) => this.getMail_users(res))
    // this.getMail_users();
  },
  methods: {
    getMail_users(data) {
      if (!data) return;
      this.mail_data = Object.assign({}, data);
    },
    showPass() {
      this.passwordFieldIdType = this.passwordFieldIdType === 'password' ? 'text' : 'password';
    },
    validation() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.setPassword();
      }
    },
    setPassword() {
      setPass(this.mail_data, (e) => this.requestSetPass(e))
    },
    requestSetPass(e) {
      if (e.isOK) {
        return this.errors.push(e.text);
      }
      this.success = true;
      setTimeout(() => {
        routerGoToName('BankSettings');
        // this.$router.push({path: '/account/settings'})
      }, 900)
    }


  }
}
</script>

<style lang="scss" scoped>
.form-item .errorText {
  display: none;
  //font-size: 1rem !important;
  color: #cb203d;
}

.form-item {
  &.errorInput .errorText {
    display: block;
  }
}

.error {
  border-color: #ff002a !important;
  border-style: solid !important;
  border-width: 2px !important;
  border-radius: .3rem;
}
</style>
